import React from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { ChangePasswordAccessManagementUsers } from "store/middlewares/membersAndRoles/teamMembers";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Label,
  PasswordInput,
} from "components/ui";

function ModalChangePassword({ row }) {
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    let tempObj = { ...values };
    if (row) {
      tempObj = {
        ...tempObj,
        id: row?.id,

        password: values.password,
      };
      dispatch(ChangePasswordAccessManagementUsers(tempObj));
    }
  };

  const formik = useFormik({
    initialValues: {
      password: row?.password ? row.password : "",
      confirmPassword: row?.confirmPassword ? row.confirmPassword : "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("New Password  is required"),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("password"), null],
          "New password and confirm password must be same"
        )
        .required("Confirm Password  is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  // useEffect(() => {
  //   console.log(formik.errors);
  // }, [formik]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Change Password</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">New Password</Label>
              <PasswordInput
                error={formik.errors.password && formik.touched.password}
                errorMsg={formik.errors.password}
                value={formik.values.password}
                name="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter New Password"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Confirm Password</Label>
              <PasswordInput
                error={
                  formik.errors.confirmPassword &&
                  formik.touched.confirmPassword
                }
                errorMsg={formik.errors.confirmPassword}
                value={formik.values.confirmPassword}
                name="confirmPassword"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Confirm Password"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              <Button type={"submit"}>Update</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalChangePassword;
